const CONVERSATION_ID_MATCHING_REGEX = /(?<=contact-landing-page\/)[^/]*/g;
/**
 * Attempts to retrieve the conversationId from the current URL. If the conversationId
 * can't be parsed from the URL, undefined is returned.
 *
 * @returns conversationId retrieved from the current URL or undefined on failure
 */
export function getConversationIdFromURL() {
    var _a;
    return (_a = window.location.hash.match(CONVERSATION_ID_MATCHING_REGEX)) === null || _a === void 0 ? void 0 : _a[0];
}
//# sourceMappingURL=GetConversationIdFromURL.js.map